module.exports = __webpack_public_path__ + "./img/notinterested.ad11a8c6ec14d2bcb3538310c98c92b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/notinterested.png
// module id = ./src/containers/Briefcase/entry/icons/notinterested.png
// module chunks = 0